import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../../global/Authorize";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class TermWise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      fakeData: [1, 2, 3, 4, 5, 6],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetch({
      session: this.props.user.session.id,
    });
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get(`/api/termwiseoverallfeereport`, { params: { ...params } })
      .then((res) => {
        this.setState({ data: res.data, loading: false });
      })
      .catch((e) => this.setState({ loading: false }));
  };

  render() {
    const { loading, data, fakeData } = this.state;

    return (
      <Authorize roles={["IS_ADMIN", "IS_SUPERADMIN"]} redirect to="/login">
        <Header to="/home" title="Fee Statistics" />

        <div className="d-flex flex-row th-no-scroll pt-2">
          <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
            <div className="th-primary">Term Wise</div>
            <hr
              className="w-100 my-1 th-border"
              style={{ borderWidth: 5, borderRadius: 5 }}
            />
          </div>
          <Link style={{ textDecoration: "none" }} to="/classWiseFee">
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-black">Class Wise</div>
            </div>
          </Link>
        </div>

        <div className="container my-3 col-12">
          {loading ? (
            <div>
              {fakeData.map((item, i) => {
                return (
                  <div className="shadow-sm p-3 mt-2" key={i}>
                    <Skeleton width={120} />
                    <Skeleton count={4} />
                  </div>
                );
              })}
            </div>
          ) : null}

          {loading === false && data !== 0
            ? data?.map((item, i) => {
                return (
                  <div className="shadow-sm p-3 mt-2" key={i}>
                    <div className="th-14 th-medium">
                      {item.fee_group__term_fee__term_name}
                    </div>
                    <div className="th-grey">
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Balance: </span>
                        {item.balance}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Fee Paid: </span>
                        {item.paid_fee}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Total Fee: </span>
                        {item.total_fee}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Adjustment Fee: </span>
                        {item.adjustment_fee}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(TermWise);
